@if (path !== "") {
  <div class="tw:h-full tw:w-full tw:flex tw:items-center tw:justify-center">
    <div class="tw:flex tw:flex-row tw:mb-40 tw:flex-wrap tw:justify-center tw:items-center">
      <div class="tw:flex tw:flex-col tw:mr-16 tw:mt-4">
        <h1 class="error-code tw:m-0">404</h1>
        <p class="error-message">{{ "MESSAGE.PAGE_NOT_FOUND" | translate }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:mt-4">
        <p class="tw:mb-1">{{ "PAGE_NOT_FOUND.URL_NOT_AVAILABLE" | translate }}</p>
        <div>{{ "PAGE_NOT_FOUND.CHECK_ADDRESS" | translate }}</div>
        <p class="tw:m-0 tw:mt-7">
          {{ "PAGE_NOT_FOUND.CONTACT_TECHNICAL_SUPPORT" | translate }}
          <a class="support-link" href="mailto:technical@navtor.com">technical&#64;navtor.com</a>
        </p>
      </div>
    </div>
  </div>
}
